import { Component, OnInit } from '@angular/core';
import { Console } from '@angular/core/src/console';
import { Http } from '@angular/http';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { interval } from 'rxjs/observable/interval';
import { timer } from 'rxjs/observable/timer';
import { environment } from '../../environments/environment';
import { Helpers } from '../helpers';
import { TranslateConfigService } from '../theme/home/translateConfig.service';
import { appService } from '../_services/app.service';
import { NavService } from '../_services/NavService.service';
import { ScriptLoaderService } from '../_services/script-loader.service';
import { DecryptPipe } from '../auth/_services/encrypt-decrypt.pipe';
const LNG_KEY = "SELECTED_LANGUAGE";
declare var $: any;
declare var google: any;

@Component({
  selector: 'app-book-dash-new',
  templateUrl: './book-dash-new.component.html',
  styleUrls: ['./book-dash-new.component.scss']
})
export class BookDashNewComponent implements OnInit {

  //Add trupti 23-oct-2021
  maps: any;
  bookingId: any;
  consignmentDetailId: any;
  CompanyId: any;
  UserId: any;
  locations: any = [];
  liveTrackData: any = {};
  hostURL = environment.apiUrl;
  APIUrl = environment.apiUrl;
  static bookDashNewComponent: BookDashNewComponent;
  datatable: any;
  vehicleType: string;
  GetVehicleList = [];
  GetVehicleCount = [];
  driverName: string;
  toNameStyle: any;
  searchValue: string;
  updateSubscription: Subscription;
  dynamicIndex = -1;
  allVehicleList: any;
  transistTripCount: number;
  assignTripCount: number;
  whitelabelFlag: boolean = false;

  constructor(private service: TranslateConfigService,
    private apiService: appService,
    private http: Http,
    private toastr: ToastrService, private cookieService: CookieService,
    private _navService: NavService, private _script: ScriptLoaderService,
    private decryptpipe: DecryptPipe) {

    BookDashNewComponent.bookDashNewComponent = this;
  }
  isShaw = true;
  ratecard() {
    this.isShaw = !this.isShaw;
  }
  changeColour(vehicleStatusColour) {
    let color = '';
    if (vehicleStatusColour == "Idle") {
      color = '#EA4335';
    }
    else if (vehicleStatusColour == "Assigned") {
      color = '#FBBC05';
    }
    else if (vehicleStatusColour == "In-Transit") {
      color = '#34A853';
    }
    return color;
  }

  eventCheck(event) {
    if (event.target.checked == true) {
      setTimeout(() => {
        this.getAllDriversLocation();
        //window.location.reload();
      }, 20000);
    }
  }

  ngOnInit() {
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.whitelabelFlag = JSON.parse(localStorage.getItem("whitelabelFlag"));
    this.liveVehicleList('Own', '');

    this._script
      .loadScripts(
        "body",
        [
          "assets/vendors/base/vendors.bundle.js",
          "assets/demo/default/base/scripts.bundle.js"
        ],
        true
      )
      .then(() => {
        this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
        this.UserId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
        this.getAllDriversLocation();
        //  this.liveVehicleList('Own', '');
        // this.GetLiveTrackListForBookingFromURL();
        setTimeout(() => {
          this._navService.navItem$.subscribe((item) => {
            if (this.CompanyId !== JSON.parse(localStorage.getItem("ChnageCompnayId")).Id) {
              if (this.datatable) this.datatable.destroy();
              this.getAllDriversLocation();
            }
          });
        }, 500);
      });
  }


  liveVehicleList(type: string, searchValue: string) {
    this.vehicleType = type;
    this.searchValue = searchValue;
    this.apiService.GetByThreeId("BookDashNew", "TripDocumentPrintGetList", this.CompanyId, this.vehicleType, this.searchValue).subscribe((response) => {
      console.log(response)
      this.GetVehicleList = response.Table;
      this.GetVehicleCount = response.Table1;
      this.tripcount();
    })
  }

  getAllDriversLocation() {
    this.apiService
      .GetById("DriverMobileOrders", "GetAllDriverLocation", this.CompanyId)
      .subscribe((res) => {
        this.locations = res as any;
        console.log(this.locations)
        // this.locations.forEach(element => {
        //   this.vehicleType = 'Attached,Own,Hired';
        //   this.apiService.GetByThreeId("BookDashNew", "TripDocumentPrintGetList", this.CompanyId, this.vehicleType, this.searchValue).subscribe((response) => {
        //     console.log(response)
        //     var allVehicleList = response.Table;

        //     allVehicleList.forEach(el => {
        //       if (el.vehicleNo == element.vehicleNo) {
        //         console.log('match status')
        //       }
        //       else {
        //         console.log(' not match status')
        //       }
        //     });

        //   })

        // });

        if (this.locations[0].GPSTrackingUrl != null) {

          this.getGPSLiveTrackLocation(this.locations[0].GPSTrackingUrl).subscribe((data) => {
            if (data.root.VehicleData != undefined) {
              var companyAddress = this.locations[0].companyAddress;
              console.log(companyAddress)
              this.locations = [];

              data.root.VehicleData.forEach(element => {

                this.vehicleType = 'Attached,Own,Hired';
                this.apiService.GetByThreeId("BookDashNew", "TripDocumentPrintGetList", this.CompanyId, this.vehicleType, this.searchValue).subscribe((response) => {
                  console.log(response)
                  this.allVehicleList = response.Table;

                  var removeSpaceFromVehicleNo = element.Vehicle_No.replace(/\s/g, "");
                  console.log('remove white space', removeSpaceFromVehicleNo)
                  var vehicleList = this.allVehicleList.find(x => x.vehiceNo == removeSpaceFromVehicleNo);
                  console.log(vehicleList);
                  if (vehicleList.vehicleStatus != undefined) {
                    element.vehicleStatus = vehicleList.vehicleStatus;
                    console.log(element.vehicleStatus)
                  } else {
                    element.vehicleStatus = 'Idle';
                  }


                  // allVehicleList.forEach(el => {

                  //   if (el.vehiceNo == xyz) {
                  //     element.vehicleStatus = el.vehicleStatus;
                  //     this.vehicleStatus = element.vehicleStatus;
                  //     //  var abc = element.vehicleStatus;
                  //     console.log(this.vehicleStatus)
                  //     console.log('match status')
                  //   }
                  //   else {
                  //     console.log(' not match status')
                  //   }
                  // });

                  var obj: any = {};
                  obj.driverLocationLAT = parseFloat(element.Latitude);
                  obj.driverLocationLNG = parseFloat(element.Longitude);
                  obj.driverMobileNo = '';
                  obj.vehicleNo = element.Vehicle_No;
                  obj.driverName = element.Driver_First_Name;
                  obj.companyAddress = companyAddress;
                  obj.vehicleStatus = element.vehicleStatus;
                  this.locations.push(obj);
                  this.initMap();
                })

              });
            }
            // setTimeout(() => {
            //   this.initMap();
            // }, 1000);
          },
            (error) => {
              this.toastr.error(error._body.replace(/"/g, ""), "Error");
              Helpers.setLoading(false);
            });
        }
        this.initMap();
      });
  }
  getGPSLiveTrackLocation(URL: any) {

    return this.http.get(URL).map((response: any) => response.json());
  }

  initMap() {

    const directionsService = new google.maps.DirectionsService();
    const directionsRenderer = new google.maps.DirectionsRenderer();
    const map = new google.maps.Map(document.getElementById("directionMap"), {
      zoom: 6,
      center: { lat: 22.121266, lng: 68.773247 },
    });
    //  const image = "../../../assets/img/truck.png";
    this.locations.forEach(element => {

      let image;
      if (element.vehicleStatus == 'In-Transit') {
        image = "../../assets/app/media/img/logos/green-map.png"
      }
      else if (element.vehicleStatus == 'Assigned') {
        image = "../../assets/app/media/img/logos/truck-map.png"
      }
      else if (element.vehicleStatus == 'Idle') {
        image = "../../assets/app/media/img/logos/idle-map.png"
      }

      const beachMarker = new google.maps.Marker({
        position: { lat: element.driverLocationLAT, lng: element.driverLocationLNG },
        map,
        icon: image,
        title: element.vehicleNo,
        width: '10px'
      });
      const infoWindow = new google.maps.InfoWindow();
      beachMarker.addListener("click", () => {

        beachMarker.setAnimation(google.maps.Animation.BOUNCE);
        setTimeout(() => {
          beachMarker.setAnimation(null);
        }, 2000);
        infoWindow.close();
        infoWindow.setContent('<table style="table-layout: fixed;">' +
          '<tr>' +
          '<td style="font-weight: bold">Vehicle No:</td>' +
          '<td>' + element.vehicleNo + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td style="font-weight: bold">Driver:</td>' +
          '<td>' + element.driverName + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td style="font-weight: bold">Driver Mobile No:</td>' +
          '<td>' + element.driverMobileNo + '</td>' +
          '</tr>' +
          '</table>');
        infoWindow.open(beachMarker.getMap(), beachMarker);
      });
      directionsRenderer.setMap(map);
      this.calculateAndDisplayRoute(directionsService, directionsRenderer);
    });

  }
  loadMap(location) {
    const map = new google.maps.Map(document.getElementById("directionMap"), {
      zoom: 6,
      center: { lat: 20.5937, lng: 78.9629 },
    });
    const image = "../../../assets/img/truck.png";
    // this.locations.forEach(element => {
    const beachMarker = new google.maps.Marker({
      position: { lat: location.driverLocationLAT, lng: location.driverLocationLNG },
      map,
      icon: image,
      title: location.vehicleNo,
    });
    const infoWindow = new google.maps.InfoWindow();
    beachMarker.addListener("click", () => {

      beachMarker.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(() => {
        beachMarker.setAnimation(null);
      }, 2000);
      infoWindow.close();
      infoWindow.setContent('<table style="table-layout: fixed;">' +
        '<tr>' +
        '<td style="font-weight: bold">Vehicle No:</td>' +
        '<td>' + location.vehicleNo + '</td>' +
        '</tr>' +
        '<tr>' +
        '<td style="font-weight: bold">Driver:</td>' +
        '<td>' + location.driverName + '</td>' +
        '</tr>' +
        '<tr>' +
        '<td style="font-weight: bold">Driver Mobile No:</td>' +
        '<td>' + location.driverMobileNo + '</td>' +
        '</tr>' +
        '</table>');
      infoWindow.open(beachMarker.getMap(), beachMarker);
    });
    // directionsRenderer.setMap(map);
    //  this.calculateAndDisplayRoute(directionsService, directionsRenderer);
    // });
  }
  calculateAndDisplayRoute(directionsService, directionsRenderer) {

    directionsService
      .route({
        origin: {
          query: this.liveTrackData.originAddress,
        },
        destination: {
          query: this.liveTrackData.destinationAddress,
        },
        travelMode: google.maps.TravelMode.DRIVING,
      })
      .then((response) => {
        directionsRenderer.setDirections(response);
      })
    //  .catch((e) => window.alert("Directions request failed due to " + status));
  }

  GetLiveTrackListForBooking(bookingId, consignmentDetailId, vehicleNo) {

    Helpers.setLoading(true);
    if (bookingId != null && bookingId != undefined) {
      // console.log('GPSUrl', this.locations[0].GPSTrackingUrl, 'vehicalNo', vehicleNo)
      // this.apiService.GetByTwoId("BookDashNew", "getVehicleLocation", this.locations[0].GPSTrackingUrl, vehicleNo).subscribe((response) => {
      //   console.log(response)

      //   setTimeout(() => {
      //     
      //     this.getGPSLiveTrackLocation(this.liveTrackData.GPSTrackingUrl).subscribe((data) => {
      //       
      //       if (data.root.VehicleData != undefined) {
      //         this.liveTrackData.driverLocationLAT = parseFloat(data.root.VehicleData[0].Latitude);
      //         this.liveTrackData.driverLocationLNG = parseFloat(data.root.VehicleData[0].Longitude);
      //       }
      //       this.initMap();
      //     })
      //     // this.getGPSLiveTrackLocation(this.locations[0].GPSTrackingUrl).subscribe((data) => {
      //     //   
      //     //   if (data.root.VehicleData != undefined) {
      //     //     this.liveTrackData.driverLocationLAT = parseFloat(data.root.VehicleData[0].Latitude);
      //     //     this.liveTrackData.driverLocationLNG = parseFloat(data.root.VehicleData[0].Longitude);
      //     //   }
      //     //   this.loadMap(this.locations[0]);
      //     // })
      //   }, 1000);
      //   // this.initMap();
      // })
      this.apiService.GetByTwoId("Booking", "GetLiveTrackListForBooking", bookingId, consignmentDetailId).subscribe((response) => {

        Helpers.setLoading(false);
        console.log(response)
        this.liveTrackData = response.Table[0];
        this.liveTrackData.documentList = [];
        this.liveTrackData.documentList.push(response.Table1[0]);
        this.liveTrackData.orderDetailsList = [];
        this.liveTrackData.orderDetailsList.push(response.Table2[0]);
        this.liveTrackData.documentList.forEach(element => {
          if (element.documentFileName !== null) {
            element.documentFileName = element.documentFileName.split(/_(.+)/)[1] + '.' + element.documentFileExtension;
          }
        });
        this.initMap();
      },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
          Helpers.setLoading(false);
        });
    }
  }


  GetLiveTrackListForBookingFromURL() {
    Helpers.setLoading(true);
    this.getByTwoIdLiveTrack(this.bookingId, this.consignmentDetailId).subscribe((data) => {
      this.liveTrackData = data.Table[0];
      this.liveTrackData.documentList = [];
      this.liveTrackData.documentList.push(data.Table1[0]);
      this.liveTrackData.orderDetailsList = [];
      this.liveTrackData.orderDetailsList.push(data.Table2[0]);
      this.liveTrackData.documentList.forEach(element => {
        if (element.documentFileName !== null) {
          element.documentFileName = element.documentFileName.split(/_(.+)/)[1] + '.' + element.documentFileExtension;
        }
      });
      if (this.liveTrackData.GPSTrackingUrl != null) {
        this.getGPSLiveTrackLocation(this.liveTrackData.GPSTrackingUrl).subscribe((data) => {
          if (data.root.VehicleData != undefined) {
            this.liveTrackData.driverLocationLAT = parseFloat(data.root.VehicleData[0].Latitude);
            this.liveTrackData.driverLocationLNG = parseFloat(data.root.VehicleData[0].Longitude);
          }
          this.initMap();
        },
          (error) => {
            this.toastr.error(error._body.replace(/"/g, ""), "Error");
            Helpers.setLoading(false);
          });
      } else {
        this.initMap();
      }
      Helpers.setLoading(false);
    },
      (error) => {
        this.toastr.error(error._body.replace(/"/g, ""), "Error");
        Helpers.setLoading(false);
      });
  }

  getByTwoIdLiveTrack(id: any, param1: any) {
    return this.http.get(environment.apiUrl + 'api/Booking/GetLiveTrackListForBooking/?id=' + id + '&param1=' + param1).map((response: any) => response.json());
  }

  changeVehicleType(e) {
    this.vehicleType = e.target.value;
    this.liveVehicleList(this.vehicleType, '');
  }

  onKeypressEvent(event: any) {
    this.liveVehicleList(this.vehicleType, event.target.value);
  }
  tripLocation(bookingId) {
    window.open("/LiveTracking?bookingId=" + bookingId + "&consignmentDetailId=null")
  }

  listOfVehicle(vehicleStatus: string, index: number) {
    if (this.dynamicIndex !== index) {
      this.liveVehicleList(this.vehicleType, vehicleStatus)
      this.dynamicIndex = index;
    }
    else {
      this.liveVehicleList(this.vehicleType, '')
      this.dynamicIndex = -1;
    }
  }

  tripcount() {

    let transistCount = 0;
    let assignCount = 0;
    this.GetVehicleList.forEach(el => {

      el.vehicleStatus;
      if (el.vehicleStatus == 'In-Transit') {
        transistCount++;
        this.transistTripCount = transistCount;
        console.log(transistCount)
      }
      if (el.vehicleStatus == 'Assigned') {
        assignCount++;
        this.assignTripCount = assignCount;
        console.log(assignCount)
      }
    })
  }
}
